import { useCallback } from 'react'

import { useLocation, useNavigate } from 'Pods/Shared/ContextBasedRouter'
import { buildSharedRunPathname } from 'Pods/ThreeDStudio/Hooks/buildSharedRunPathname'
import { threeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setOpenedModel } from 'Pods/ThreeDStudio/Store/actions/ui'

function useOpenVariation({ id, slug, title }) {
  const navigate = useNavigate()
  const location = useLocation()

  const handleClick = useCallback(() => {
    const targetPathname = buildSharedRunPathname({ id, slug, title })
    if (location?.pathname !== targetPathname) {
      navigate(targetPathname, { state: { keepVariationsTab: true } })
      return
    }
    // Same URL, so no navigation (and no useModelUrlSync re-open) fires. This
    // happens when the uploaded-source card replaced this run in the viewer;
    // re-open the run from the store to load it back.
    const { ui, modelSettings } = threeDStudioStore.getState()
    if (modelSettings?.inputThreeDUrl && ui?.openedModel?.id != null) {
      setOpenedModel(ui.openedModel, { keepVariationsTab: true })
    }
  }, [navigate, location, id, slug, title])

  const handleKeyDown = useCallback((e) => {
    // Keys pressed on the nested buttons must keep their own activation.
    if (e.target !== e.currentTarget) {
      return
    }
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      handleClick()
    }
  }, [handleClick])

  // Opening the run without keepVariationsTab lets its parser show the panel that made
  // it, prefilled with the run's settings: the related enhancement tab, or the Generate
  // 3D Model panel for base generations.
  const handleOpenRelatedTab = useCallback((e) => {
    e.stopPropagation()
    const targetPathname = buildSharedRunPathname({ id, slug, title })
    if (location?.pathname !== targetPathname) {
      navigate(targetPathname)
      return
    }
    const { openedModel } = threeDStudioStore.getState().ui
    if (openedModel?.id != null) {
      setOpenedModel(openedModel)
    }
  }, [navigate, location, id, slug, title])

  return { handleClick, handleKeyDown, handleOpenRelatedTab }
}

export default useOpenVariation
